import Header from "./components/Header";
import Hero from "./components/Hero";
import Ticker from "./components/Ticker";
import Tracking from "./components/Tracking";
import Reversal from "./components/Reversal";
import Feed from "./components/Feed";
import Ranking from "./components/Ranking";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Ticker />
        <Tracking />
        <Reversal />
        <Feed />
        <Ranking />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}